import React, {Fragment, useState} from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';

import { SingleDatePicker } from 'react-dates';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';
import Cx from 'classnames';

import Upload from 'Components/Upload/index';
import { ReactComponent as DeleteIcon } from 'Icons/delete.svg';
import { BEAM } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import { isVishaka } from 'Utils/index';

const ConfirmationRemarksPopup = (props) => {
    const [remarksError, setRemarksError] = useState('');

    const handleConfirm = () => {
        if (props.remarksRequired && !(props.instructionsValue || '').trim()) {
            setRemarksError('Remarks are required.');
            return;
        }
        setRemarksError('');
        props.onConfirm();
    };

    return (
    <Fragment>
        <Overlay>
            <div className="bg-white box-shadow ph-20 pv-20 br-5">
                <div className="mb-30 tCenter header-medium-color fSemibold fs-18">
                    {props.text}
                </div>
                {
                    props.hasRemarks &&
                    <div className="mb-10 tCenter header-medium-color fSemibold fs-18">
                        <div className="mb-10 tCenter header-medium-color fSemibold fs-14"> From </div>
                        <div className={Cx("flex pb-10 mb-10 mt--1", {
                            'notselectable': props.isEditable
                        })}>
                            <SingleDatePicker
                                noBorder={true}
                                displayFormat={"DD MMM YYYY"}
                                hideKeyboardShortcutsPanel={true}
                                placeholder={"Placement Date"}
                                numberOfMonths={2}
                                date={Moment(props.acceptLoiFrom)}
                                onDateChange={(from) =>{
                                    const date = from.format('YYYY-MM-DD') + ' ' + Moment(props.acceptLoiFrom).format('HH:mm');
                                    props.onFromDateChange(new Date(date).getTime());
                                }}
                                focused={props.focusedFrom}
                                onFocusChange={({ focused }) => { props.onFocusedFrom(focused); }}
                            />
                            <TimePicker
                                showSecond={false}
                                value={Moment(props.acceptLoiFrom)}
                                className="ht-40 wt-150 border-status-bar br-5"
                                onChange={(from) =>{
                                    const date = Moment(props.acceptLoiFrom).format('YYYY-MM-DD') + ' ' + from.format('HH:mm');
                                    props.onFromDateChange(new Date(date).getTime());
                                }}
                                minTime={props.systemTime ? new Date(props.systemTime) : new Date()}
                                format={'h:mm a'}
                                use12Hours
                                inputReadOnly
                            />
                        </div>

                        <div className="mb-10 tCenter header-medium-color fSemibold fs-14"> To </div>
                        <div className={Cx("flex pb-10 mb-20 mt--1", {
                            'notselectable': props.isEditable
                        })}>
                            <SingleDatePicker
                                noBorder={true}
                                displayFormat={"DD MMM YYYY"}
                                hideKeyboardShortcutsPanel={true}
                                placeholder={"Placement Date"}
                                numberOfMonths={2}
                                date={Moment(props.acceptLoiTo)}
                                onDateChange={(from) =>{
                                    const date = from.format('YYYY-MM-DD') + ' ' + Moment(props.acceptLoiTo).format('HH:mm');
                                    props.onToDateChange(new Date(date).getTime());
                                }}
                                focused={props.focusedTo}
                                onFocusChange={({ focused }) => { props.onFocusedTo(focused); }}
                            />
                            <TimePicker
                                showSecond={false}
                                value={Moment(props.acceptLoiTo)}
                                className="ht-40 wt-150 border-status-bar br-5"
                                onChange={(from) =>{
                                    const date = Moment(props.acceptLoiTo).format('YYYY-MM-DD') + ' ' + from.format('HH:mm');
                                    props.onToDateChange(new Date(date).getTime());
                                }}
                                minTime={props.systemTime ? new Date(props.systemTime) : new Date()}
                                format={'h:mm a'}
                                use12Hours
                                inputReadOnly
                            />
                        </div>

                    </div>
                }
                {props.tk11_type_name &&
                    <div className="mb-15 header-medium-color fSemibold fs-14">
                        Tk11 Details : <span className="theme-color">{props.tk11_type_name || ""}</span>
                    </div>

                }
                {
                    props.hasInput &&
                    <Fragment>
                        {props.rfq.loiWithChallengePrice &&  props.rfq && props.rfq.type !== 5 && <div className="mb-10 header-medium-color fSemibold fs-14">
                            <input type="checkbox" className={'mb-10'} name="loiWithCPPrice" onClick={(e) => {e.stopPropagation();props.loiWithCPPriceChange(e)}}/>
                         With Challenge Price
                         <Input
                                        type="number"
                                        placeholder="Challenge Price"
                                        onChange={(e) => props.onCPChange(e)}
                                        value={props.cpPrice !== 0.0? props.cpPrice : ""}
                                        name="cpPrice"
                                        className="fs-14 no-border"
                                        noTransition={true}
                                        containerClassName="no-transition-container"
                                    />
                        </div>
                        }
                        <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                            You May Enter Instructions For The Transporter If Required.
                        </div>
                        <Input name="seekerRemarks" value={props.value} onChange={(e) => props.onChange(e)} />
                    </Fragment>
                }
                {
                    props.hasRemarks &&
                    <div className="mb-10 tCenter header-medium-color fSemibold fs-18 mt-10">
                        <div className="mb-10 tCenter header-medium-color fSemibold fs-14">
                            You May Enter Remarks For Yourself.{props.remarksRequired && <span className="error-color ml-5">*</span>}
                        </div>
                        <Input
                            name="seekerInstructions"
                            value={props.instructionsValue}
                            onChange={(e) => { setRemarksError(''); props.onChangeInstructions(e); }}
                        />
                        {remarksError && <div className="error-color fs-12 mt-5">{remarksError}</div>}
                    </div>
                }
                {
                    props.hasRemarks && (BEAM.includes(getUser().companyId) || isVishaka(getUser().companyId)) &&
                    <div className='mt-10 tCenter'>
                        <Upload onChange={props.onUploadLoiDocs}>
                            <button className="ht-30 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" >Upload File</button>
                        </Upload>
                        {(props.loi_docs || []).map(doc => (
                            <div className='mt-5'>
                                <a onClick={() => props.downloadUploadedFile(doc.name)}>{doc.name}</a>
                                <DeleteIcon className={'wt-18 ht-18 ml-20 curP'} onClick={() => props.deleteDoc()}></DeleteIcon>
                            </div>
                        ))}
                    </div>
                }
                <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={props.onCancel}>Cancel</button>

                   <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" onClick={handleConfirm}>{props.hasInput ? <Fragment>{props.onSendAndApprover}</Fragment> : <Fragment>Confirm</Fragment>}</button>

                </div>
            </div>
        </Overlay>
    </Fragment>
    );
};

export default ConfirmationRemarksPopup;
